import AbstractRepository from "@/repositories/AbstractRepository";

export default class BudgetAllocationRepository extends AbstractRepository {
    protected static resource: string = "ptf-budget-budgetallocation";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
        "budget.uuid",
        "allocationType.uuid"
    ];
}
